RivalIQ.apps.Site.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Main = Marionette.View.extend({
        events: {
            'click .x-contact-button.x-vip': 'onContactVipClicked',
            'click .x-contact-button.x-startup': 'onContactStartupClicked',
            'click .x-contact-button.x-demo': 'onDemoRequestClicked',
            'click a.x-sample-download': 'onSampleDownload'
        },
        onContactVipClicked: function () {
            App.execute('contact:show', 'vip');
        },
        onContactStartupClicked: function () {
            App.execute('contact:show', 'startup/non-profit');
        },
        onDemoRequestClicked: function () {
            App.execute('contact:show', 'demo');
        },
        onSampleDownload: function (e) {
            const currentTarget = $(e.currentTarget);
            const reportName = currentTarget.attr('name');
            const fileType = currentTarget.attr('type');

            RivalIQ.execute('tracking:push',
                RivalIQ.tracking.metric.DownloadedSampleReportFromChannel,
                {
                    name: reportName,
                    fileType: fileType
                }
            );
        }
    });

});
